class LocalstorageService {
  setAuthTokens(accessToken: string, refreshToken: string, email?: string): void {
    this.setLocalAccessToken(accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    if (email) {
      localStorage.setItem("authEmail", email);
    }
  }

  setLocalAccessToken(token: string): void {
    const bearerToken = token.startsWith("Bearer ") ? token : "Bearer " + token;
    localStorage.setItem("token", bearerToken);
    localStorage.setItem("accessToken", token.replace("Bearer ", ""));
  }

  getLocalAccessToken() {
    return localStorage.getItem("token");
  }

  getRefreshToken() {
    return localStorage.getItem("refreshToken");
  }

  getAuthEmail() {
    return localStorage.getItem("authEmail");
  }

  clearAuthTokens(): void {
    localStorage.removeItem("token");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("authEmail");
  }
}

const localStorageService = new LocalstorageService();
export default localStorageService;
